import moment from "moment";

export const filterSpecialtiesHavingAppointmentTypes = specialties => {
  return specialties.filter(f => f.appointmentTypes.length > 0);
};

export const filterPractitionersBySpecialty = (
  practitioners,
  specialtyType
) => {
  return practitioners.filter(p =>
    p.specialties.map(s => s.specialtyTypeId).includes(specialtyType)
  );
};

export const filterSchedulesByPractitioner = (
  schedules,
  practitioner = "",
  locationFirst = false,
  autoSelectAnyPractitioner = false
) => {
  if (
    practitioner === "" ||
    practitioner === "ANY" ||
    locationFirst ||
    autoSelectAnyPractitioner
  )
    return schedules;
  return schedules.filter(s => s.practitionerId === practitioner);
};

export const filterSchedulesByLocation = (schedules, location = "") => {
  if (location === "" || location === "ANY") return schedules;
  return schedules.filter(
    s =>
      s.Sessions[0].locationId === location ||
      s.Sessions[1].locationId === location
  );
};

export const filterLocationsBySchedules = (locations, schedules) => {
  const locationIdsInSchedule = schedules.reduce((current, next) => {
    const sessions = next.Sessions;
    if (!current.includes(sessions[0].locationId)) {
      current.push(sessions[0].locationId);
    }
    if (!current.includes(sessions[1].locationId)) {
      current.push(sessions[1].locationId);
    }
    return current;
  }, []);
  return locations.filter(l => {
    return locationIdsInSchedule.includes(l.locationId);
  });
};

export const filterPractitionersBySchedules = (practitioners, schedules) => {
  const practitionerIdsInSchedule = schedules.map(s => s.practitionerId);

  return practitioners.filter(p =>
    practitionerIdsInSchedule.includes(p.practitionerId)
  );
};

export const filterTimeSlotsByLocationAndPractitioner = (
  timeslots,
  location,
  practitioner
) => {
  return timeslots.filter(
    ts =>
      moment(ts.startDateTime).isAfter(moment().add(30, "minutes")) &&
      (ts.locationId === location || location === "ANY" || !location) &&
      (ts.practitioner.practitionerId === practitioner ||
        practitioner === "ANY" ||
        !practitioner)
  );
};

export const isTimeZoneUnique = locations => {
  const timeZones = locations
    .filter(l => l.timeZone !== null)
    .reduce((current, next) => {
      if (!current.includes(next.timeZone.timezoneId))
        current.push(next.timeZone.timezoneId);

      return current;
    }, []);

  return timeZones.length <= 1;
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/helpers/filterHelpers.js